import { makeStyles } from '@material-ui/core';

export const useMetadataStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: '0 4px 12px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.1)',
    border: 'none',
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  card: {
    boxShadow: '0 4px 12px rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.1)',
    border: 'none',
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: '#ffffff',
  },
  cardContent: {
    padding: 0,
  },
  header: {
    padding: theme.spacing(2),
    backgroundColor: 'white',
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  headerIcon: {
    fontSize: 24,
    color: theme.palette.primary.main,
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  headerTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1.125rem',
    letterSpacing: '0.00735em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  content: {
    padding: theme.spacing(3),
    animation: '$fadeIn 400ms ease-out',
  },
  metadataItemPaper: {
    borderRadius: 4,
    boxShadow: '0px 1px 0px 0px rgba(0,0,0,0.2),0px 0px 8px 0px rgba(0,0,0,0.14),0px 0px 0px 0px rgba(0,0,0,0.12)',
    overflow: 'hidden',
    transition: theme.transitions.create(['box-shadow', 'transform'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      boxShadow: '0 6px 16px rgba(0,0,0,0.12), 0 3px 6px rgba(0,0,0,0.08)',
      transform: 'translateY(-2px)',
    },
  },
  metadataItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    backgroundColor: 'white',
    minHeight: 56,
    border: 'none',
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
    backgroundColor: 'transparent',
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  metadataContent: {
    flex: 1,
    minWidth: 0,
  },
  fieldLabel: {
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: theme.spacing(0.25),
    display: 'block',
    lineHeight: 1.2,
  },
  fieldValue: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.3,
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
  },
  chip: {
    fontSize: '0.75rem',
    fontWeight: theme.typography.fontWeightMedium,
    height: 24,
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create(['transform', 'box-shadow'], {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      transform: 'scale(1.02)',
      boxShadow: theme.shadows[2],
    },
  },
  // Legacy styles for backward compatibility
  contentContainer: {
    flex: 1,
    display: 'flex',
    width: '100%',
  },
  leftColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: 'white',
  },
  rightColumn: {
    width: '50%',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  list: {
    padding: 0,
    height: '100%',
    width: '100%',
  },
  listItem: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  listItemIcon: {
    minWidth: 48,
    marginRight: theme.spacing(1),
  },
  sizeChip: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '0.75rem',
    borderRadius: theme.shape.borderRadius * 2,
    padding: theme.spacing(0.5, 1.5),
  },
  chipXS: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark,
  },
  chipS: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.dark,
  },
  chipM: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  },
  chipL: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.dark,
  },
  chipXL: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
  // Animation classes
  fadeIn: {
    animation: '$fadeIn 600ms ease-out',
  },
  slideInLeft: {
    animation: '$slideInLeft 400ms ease-out',
  },
  slideInRight: {
    animation: '$slideInRight 400ms ease-out',
  },
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
  '@keyframes slideInLeft': {
    '0%': {
      opacity: 0,
      transform: 'translateX(-30px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
  '@keyframes slideInRight': {
    '0%': {
      opacity: 0,
      transform: 'translateX(30px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
}));
